import React, { useState, useEffect, useRef } from "react"
import PropTypes from "prop-types"
import Slider from "react-slick"
import Image from "../UI/Image/Image"
import SampleArrow from "./SampleArrow"
import styles from "./HistorySlider-tw-styles"
import "../../styles/history-slider.css"
import "../../styles/slider.css"
import { generateData } from "../../hooks/useGenerateData"
import { get } from "../../helpers/utils"
import useScreenSize from "../../hooks/useScreenSize"

const HistorySlider = props => {
  const {
    slidesCollection,
    slidesToShow,
    timelineSlidesToShow,
    heading,
    sliderId = "",
  } = props
  const slides = slidesCollection && get(slidesCollection, "items", [])
  const slider1 = useRef(null)
  const slider2 = useRef(null)
  const timeLine = []
  slides?.forEach(slide => {
    timeLine.push(slide.manufacturedYear)
  })
  const screen = useScreenSize()
  const [nav1, setNav1] = useState(null)
  const [nav2, setNav2] = useState(null)
  const [config, setConfig] = useState({
    slideData: generateData(slides, slidesToShow)?.data,
    hiddenData: generateData(slides, slidesToShow)?.discardIndexes,
    hiddenHistory: generateData(timeLine, timelineSlidesToShow)?.discardIndexes,
    historyData: generateData(timeLine, timelineSlidesToShow)?.data,
    disableBtn: false,
  })
  const setHook = next => {
    const status = next >= slides.length - 1 ? true : false
    setConfig({
      ...config,
      disableBtn: status,
    })
  }

  useEffect(() => {
    setNav1(slider1.current)
    setNav2(slider2.current)
  }, [])
  return (
    <div className={styles?.componentWrapper} id={sliderId}>
      <div className={styles?.headingOuter}>
        <h2 className={styles?.headingH2}>{heading}</h2>
      </div>
      <Slider
        asNavFor={nav2}
        ref={slider1}
        {...{
          beforeChange: (_, next) => setHook(next),
          className: styles.slidesWrapper,
          nextArrow: <SampleArrow removeBtn={config.disableBtn} title="Next" />,
          prevArrow: <SampleArrow title="Previous" />,
          slidesToShow: 3,
          slidesToScroll: 1,
          initialSlide: 0,
          arrows: true,
          autoplay: false,
          infinite: false,
          centerMode: true,
          centerPadding: "0px",
          swipeToSlide: false,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                centerMode: true,
                centerPadding: "40px",
              },
            },
          ],
        }}
      >
        {config.slideData?.map((elem, key) => {
          let customClass = ["slick-slide-inner"]
          if (config.hiddenData.includes(key)) customClass.push("slick-hidden")
          return (
            <div className={customClass.join(" ")} key={key}>
              {screen?.isDesktop ? (
                <Image
                  contentfulImage={elem?.image?.imageDesktop}
                  alt={elem?.image?.altText}
                />
              ) : (
                <Image
                  contentfulImage={elem?.image?.imageMobile}
                  alt={elem?.image?.altText}
                />
              )}
              <div className={styles?.text}>
                <h3 className={styles?.headingH3}>{elem.manufacturedYear}</h3>
                <p className={styles?.para}>{elem.description}</p>
              </div>
            </div>
          )
        })}
      </Slider>
      <div className={styles?.sliderWrapper}>
        <Slider
          asNavFor={nav1}
          ref={slider2}
          {...{
            className: styles.slidesYearWrapper,
            slidesToShow: 7,
            slidesToScroll: 1,
            arrows: false,
            autoplay: false,
            infinite: false,
            centerMode: true,
            centerPadding: "0px",
            focusOnSelect: true,
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 3,
                  centerMode: true,
                },
              },
            ],
          }}
        >
          {config.historyData?.map((elem, key) => {
            let customClass = ["slick-slide-inner-period"]
            if (config.hiddenHistory.includes(key))
              customClass.push("slick-hidden")
            return (
              <div className={customClass.join(" ")} key={elem.id}>
                <h3>{elem}</h3>
              </div>
            )
          })}
        </Slider>
      </div>
    </div>
  )
}

HistorySlider.propTypes = {
  slidesCollection: PropTypes.object,
  slidesToShow: PropTypes.number,
  timelineSlidesToShow: PropTypes.number,
  heading: PropTypes.string,
  sliderId: PropTypes.string,
}
export default HistorySlider
